module.exports = {
  "wrap": {
    "position": "relative",
    "flexDirection": "row",
    "backgroundColor": "#ffffff"
  },
  "scroller": {
    "flex": 1,
    "alignContent": "center",
    "alignItems": "center",
    "backgroundColor": "rgba(0,0,0,0)"
  },
  "item-label": {
    "position": "absolute",
    "height": "70",
    "lineHeight": "70",
    "fontFamily": "PingFangSC-Regular",
    "opacity": 0.6,
    "fontSize": "40",
    "color": "#1E2E37",
    "textAlign": "left"
  },
  "list-item": {
    "height": "70",
    "lineHeight": "70",
    "fontFamily": "PingFangSC-Regular",
    "opacity": 0.3,
    "fontSize": "40",
    "color": "#1E2E37",
    "textAlign": "center"
  },
  "list-item-left": {
    "textAlign": "left"
  },
  "first-item": {
    "marginTop": "140"
  },
  "last-item": {
    "marginBottom": "140"
  },
  "first-visible-item": {
    "opacity": 0.1,
    "fontSize": "40"
  },
  "second-visible-item": {
    "opacity": 0.3,
    "fontSize": "40"
  },
  "second-last-visible-item": {
    "opacity": 0.3,
    "fontSize": "40"
  },
  "first-last-visible-item": {
    "opacity": 0.1,
    "fontSize": "40"
  },
  "selected-item": {
    "opacity": 1,
    "color": "#1E2E37",
    "fontSize": "48"
  },
  "select-area": {
    "position": "absolute",
    "left": "0",
    "borderTopColor": "#e5e5e5",
    "borderTopWidth": "1",
    "borderBottomColor": "#e5e5e5",
    "borderBottomWidth": "1"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-fa42252a!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-scroll-picker/index.vue
// module id = 562
// module chunks = 0 1